import { Box, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';
import { colors } from 'src/theme/palette/darkPalette';

const UnsignedCatalogsInfo = ({ unsignedCount }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', position: 'absolute', left: 0, top: '-28px' }}>
    <Iconify icon="material-symbols:info-outline" color="#6B7280" width={16} height={16} />

    <Typography
      variant="body2"
      sx={{ ml: 0.5, display: 'flex', alignItems: 'center', fontSize: '12px' }}>
      unsigned catalogs indicated in
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: colors.red,
          mx: 0.5,
          border: '1px solid #fff',
          verticalAlign: 'middle',
        }}
      />
      {typeof unsignedCount === 'number' && `(${unsignedCount})`}
    </Typography>
  </Box>
);

export default UnsignedCatalogsInfo;
